<ul class="flex font-header font-bold text-primary-500 text-[0.9rem] h-full">
  @for (item of visibleMenuItems(); track item.url) {
    <li
      [class]="
        (item.color ?? 'hover:bg-primary-500') + ' hover:text-white transition-colors ease-in-out'
      "
    >
      <a
        [href]="item.url"
        [class]="
          'flex items-center h-full px-10 text-center' +
          (item.url.includes('homefinder') ? ' text-villages-gold-500' : '')
        "
      >
        {{ item.label }}
      </a>
    </li>
  }
</ul>
